import React from "react";

import "./style.css";

const Bills = () => {
  return <>{/* <div className="bills">this is bills</div> */}</>;
};

export default React.memo(Bills);
